/* eslint-disable @repo/internal/react/require-jsdoc */
import React from 'react';

import { BrandHeading, slugify } from '@af/design-system-docs-ui';
import { Box, Stack, xcss } from '@atlaskit/primitives';

import { ContentCard } from './content-card';
import type { ContentCardData, GroupData } from './types';

const gridStyles = xcss({
	display: 'grid',
	gap: 'space.100',
	gridTemplateColumns: '1fr',
	'@media (min-width: 30rem)': {
		gridTemplateColumns: '1fr 1fr',
	},
	'@media (min-width: 48rem)': {
		gridTemplateColumns: '1fr 1fr 1fr',
	},
});

type ContentCardGroupProps = {
	// eslint-disable-next-line @repo/internal/react/consistent-props-definitions
	data: GroupData<ContentCardData>[];
};

export const ContentCardGroup = ({ data }: ContentCardGroupProps) => (
	<Stack space="space.800">
		{data.map(({ title, cards }, index) => (
			<Stack key={title + index} space="space.200">
				<BrandHeading as="h2" size="large" id={slugify(title)}>
					{title}
				</BrandHeading>
				<Box xcss={gridStyles}>
					{cards.map((contentData, id) => (
						<ContentCard key={contentData.href} {...contentData} />
					))}
				</Box>
			</Stack>
		))}
	</Stack>
);
